<script setup lang="ts">
import { cn } from '@/lib/utils';
import { NavigationMenuViewport, type NavigationMenuViewportProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<NavigationMenuViewportProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div class="absolute left-0 top-full flex justify-center">
    <NavigationMenuViewport
      v-bind="forwardedProps"
      :class="
        cn(
          'origin-top-center fixed left-0 z-20 h-[--reka-navigation-menu-viewport-height] w-full overflow-hidden rounded-br-[180px] bg-anti-flash-white text-popover-foreground shadow-lg md:w-[--reka-navigation-menu-viewport-width]',
          'duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-10 data-[state=open]:fade-in-10',
          props.class
        )
      "
    />
  </div>
</template>
